import { phoneState } from '../state';

export const handleDebugInfo = (debugInfo: any) => {
  phoneState.debugInfo = debugInfo;
};
